/*
* @author: liuxu7
* @date: 2018-03-14
* @description: 气泡组件
* @type: custom/default
* @position ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']
* */
import template from './index.html'
import ko from 'knockout'
import Base from '@/core/base'
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light.css';
class Popper extends Base {
  initialize (params) {
    this.text = params.text || ko.observable('')
    let innerTemplate = params.content || ''
    let tippyEl = params.$el.firstElementChild
    let curTippy = null
    if (ko.isObservable(params.content)) {
      innerTemplate = params.content.peek()
      params.content.subscribe(val => {
        curTippy.setContent(val)
      })
    }
    if (!innerTemplate) {
      // 过滤掉html注释
      var templateNodes = params.$templateNodes.filter(item => item.nodeType !== 8)
      templateNodes.forEach(node => {
        innerTemplate += node.outerHTML || node.textContent || ''
      })
      if (innerTemplate) {
        innerTemplate = innerTemplate.trim()
      }
    }
    if (!params.content && !innerTemplate) {
      innerTemplate = this.text
      if (ko.isObservable(innerTemplate)) {
        innerTemplate = innerTemplate.peek()
        this.text.subscribe(val => {
          curTippy.setContent(val)
        })
      }
    }
    curTippy = tippy(tippyEl, {
      content: innerTemplate,
      allowHTML: true,
      theme: 'light'
    });
  }
}
export default {
  name: 'popper',
  init: Base.createViewModel(Popper),
  template
}



// WEBPACK FOOTER //
// ./src/components/popper/index.js